import { Tab } from "@headlessui/react";
import { motion } from "motion/react";
import { classes } from "lib/actions/util";
import { ForwardedRef, forwardRef, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

function SliderTab(
  p: PropsWithChildren<{
    className?: string;
    thumbClassName?: string;
    /** Also fires when the tab is already selected, unlike the tab group's onChange. */
    onClick?: () => void;
    disabled?: boolean;
  }>,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <Tab
      ref={ref}
      as="button"
      onClick={p.onClick}
      disabled={p.disabled}
      className={twMerge(
        classes(
          "relative flex-1 px-2 py-1",
          "transition-colors duration-500 data-[headlessui-state=selected]:text-neutral-800",
          "focus-visible:outline-none focus-visible:ring-0",
          "disabled:cursor-not-allowed disabled:text-neutral-400",
        ),
        p.className,
      )}
    >
      {({ selected }) => (
        <>
          {selected && <SlidingThumb className={p.thumbClassName} />}
          <div className="relative z-10">{p.children}</div>
        </>
      )}
    </Tab>
  );
}

function SlidingThumb(p: { className?: string }) {
  return (
    <motion.div
      layoutId="thumb"
      transition={{ layout: { duration: 0.25 } }}
      className={twMerge(
        "absolute inset-0 rounded-md bg-white shadow",
        p.className,
      )}
    />
  );
}

export default forwardRef(SliderTab);
